import {z} from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {PrimerComponentCardSchema} from './primerComponentCard'
import {PrimerComponentCtaBannerSchema} from './primerComponentCtaBanner'
import {PrimerComponentFaqGroupSchema} from './primerComponentFaqGroup'
import {PrimerComponentHeroSchema} from './primerComponentHero'
import {PrimerComponentPillarSchema} from './primerComponentPillar'
import {PrimerComponentRiverSchema} from './primerComponentRiver'
import {PrimerComponentRiverBreakoutSchema} from './primerComponentRiverBreakout'
import {PrimerComponentSectionIntroSchema} from './primerComponentSectionIntro'
import {PrimerComponentTestimonialSchema} from './primerComponentTestimonial'

export const TemplateF2Schema = buildEntrySchemaFor('templateF2', {
  fields: z.object({
    hero: PrimerComponentHeroSchema,
    sectionIntro: PrimerComponentSectionIntroSchema.optional(),
    pillars: z.array(PrimerComponentPillarSchema).optional(),
    rivers: z.array(z.union([PrimerComponentRiverSchema, PrimerComponentRiverBreakoutSchema])),
    testimonials: z.array(PrimerComponentTestimonialSchema).optional(),
    ctaBanner: PrimerComponentCtaBannerSchema,
    cardsHeading: z.string().optional(),
    cards: z.array(PrimerComponentCardSchema).optional(),
    faq: PrimerComponentFaqGroupSchema.optional(),
  }),
})
